export default "__VITE_ASSET__Dt6BUWJ9__"